var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3281 24.207H32.4783C33.3628 22.13 33.8105 19.9241 33.8105 17.6387C33.8105 13.1484 32.062 8.92687 28.8869 5.7518C25.7118 2.57672 21.4903 0.828125 17 0.828125C12.5097 0.828125 8.2882 2.57672 5.11312 5.7518C1.93805 8.92687 0.189453 13.1484 0.189453 17.6387C0.189453 19.9241 0.637289 22.13 1.52168 24.207H0.671875C0.40543 24.207 0.189453 24.423 0.189453 24.6895C0.189453 24.9559 0.40543 25.1719 0.671875 25.1719H33.3281C33.5946 25.1719 33.8105 24.9559 33.8105 24.6895C33.8105 24.423 33.5946 24.207 33.3281 24.207ZM3.05697 24.207C5.80766 19.133 11.1976 15.8945 17 15.8945C22.8024 15.8945 28.1924 19.133 30.943 24.207H3.05697ZM26.0741 17.587C23.3685 15.8486 20.2307 14.9297 17 14.9297C13.7693 14.9297 10.6315 15.8486 7.92587 17.587C5.57937 19.0946 3.65146 21.1511 2.3035 23.574C1.54046 21.6916 1.1543 19.6997 1.1543 17.6387C1.1543 8.90134 8.26267 1.79297 17 1.79297C25.7374 1.79297 32.8457 8.90134 32.8457 17.6387C32.8457 19.6997 32.4596 21.6916 31.6966 23.574C30.3486 21.1511 28.4207 19.0946 26.0741 17.587Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonset);
export default __webpack_public_path__ + "static/media/moonset.108721ee47eb8ebb9936c6dd9612685a.svg";
export { ForwardRef as ReactComponent };